import { ItemStatusSliceType } from "../../../services/redux/slices/itemStatusSlice";
import { ItemType, OFFER_TYPE, SubItemType } from "../../types";
import { removePercentageValue } from "../maths/maths";

export const getItemOfferOutOfStockAndCustomDeliveryTime = (
  itemStatus: ItemStatusSliceType,
  itemId: number
) => {
  let offerItem = null as unknown as ItemType;
  const isOutOfStock = itemStatus.outOfStockItemsIds.includes(itemId);

  const itemsWithOffers = itemStatus.offersItems;

  const itemIndex = itemsWithOffers.findIndex(
    (offerItem: any) => offerItem.id === itemId
  );

  if (itemIndex !== -1) {
    offerItem = { ...itemsWithOffers[itemIndex] };
  }
  const itemsWithCustomDeliveryTimes = itemStatus.itemsWithCustomDeliveryTimes;

  const customDeliveryTime =
    itemsWithCustomDeliveryTimes[itemId.toString()] || 0;

  return { offerItem, isOutOfStock, customDeliveryTime };
};

export const handleItemOfferPrice = (
  item: ItemType,
  offerItem: ItemType,
  hasRoundingMethodAndLevel: boolean
) => {
  if (!offerItem) {
    item.offer = null;

    return;
  }
  item.offer = offerItem.offer;
  item.subItems.forEach((sub, index) => {
    sub.previousPrice = offerItem.subItems[index]?.previousPrice;
    sub.price = offerItem.subItems[index]?.price;
    switch (item.offer?.offerType) {
      case OFFER_TYPE.PERCENTAGE:
        sub.allAddonGroups?.forEach((addon) => {
          addon.addonGroupSubItem?.forEach((addonGroupSubItem) => {
            if (addonGroupSubItem.previousPrice === -1) {
              addonGroupSubItem.previousPrice = addonGroupSubItem.price;
            }
            addonGroupSubItem.price = removePercentageValue(
              Number(item.offer?.offerValue),
              addonGroupSubItem.previousPrice,
              hasRoundingMethodAndLevel
            );
            if (
              addonGroupSubItem.subItem.allAddonGroups &&
              addonGroupSubItem.subItem.allAddonGroups.length > 0
            ) {
              addonGroupSubItem.subItem.allAddonGroups.forEach(
                (nestedAddonGroup) => {
                  nestedAddonGroup.addonGroupSubItem.forEach(
                    (nestedAddonGroupSubItem) => {
                      if (nestedAddonGroupSubItem.previousPrice === -1) {
                        nestedAddonGroupSubItem.previousPrice =
                          nestedAddonGroupSubItem.price;
                      }
                      nestedAddonGroupSubItem.price = removePercentageValue(
                        Number(item.offer?.offerValue),
                        nestedAddonGroupSubItem.previousPrice,
                        hasRoundingMethodAndLevel
                      );
                    }
                  );
                }
              );
            }
          });
        });
        break;
      default:
        break;
    }
  });
};

export const handleSubItemOfferPrice = (
  subItem: SubItemType,
  offerItem: ItemType,
  hasRoundingMethodAndLevel: boolean
) => {
  if (!offerItem) {
    subItem.item!.offer = null;

    return;
  }
  subItem.item!.offer = offerItem.offer!;
  subItem.previousPrice =
    subItem.previousPrice === -1 ? subItem.price : subItem.previousPrice;
  subItem.price = removePercentageValue(
    Number(subItem.item!.offer?.offerValue),
    subItem.previousPrice,
    hasRoundingMethodAndLevel
  );
};
